import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useIsMobile } from '../hooks/useIsMobile';
import MobileOnlyGate from './MobileOnlyGate';

// The app is mobile-only by design: every authenticated route shows the
// mobile gate on wide viewports, matching the gates on /login and /signup.
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const isMobile = useIsMobile();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return isMobile ? children : <MobileOnlyGate type="app" />;
};

export default ProtectedRoute;
